<template lang="pug">
  .cart-xsell-item.clearfix(:class="{'has-membership-pricing': hasMembershipPricing}")
    button.btn-reset.xs-5.sm-12.a-box-xs-1x1(type="button" @click="addItem")
      .a-box-content
        img.full-width(:src="item.imagery.standard.url" :alt="item.imagery.standard.alt_text")
        span.ada-tooltip Add to bag

    .item-details.xs-7.sm-12
      button.full-width.xs-mb-25m.xs-mt-25m.btn-reset.semi-bold.xs-f-small.max-at-tweak(type="button" @click="addItem" data-mr-ass="cross-add-to-bag")
        span.icon-pos-circle.xs-f-xmedium.max-at-tweak
        span.xs-f-small.max-at-tweak Add to bag

      p.xs-mb-25m.upper.xs-f-xsmall.max-at-tweak {{item.productTypeName}}
      p.xs-mb-25m.semi-bold.xs-f-small.max-at-tweak(data-mr-ass="cross-sell-product") {{item.name}}
      p.xs-mb-25m.light.xs-f-xsmall.max-at-tweak {{item.desc}}

      stars.xs-mb-25m(:rating="item.reviews.average")

      p.light.xs-f-small.max-at-tweak(v-if="!hasMembershipPricing") {{item.price | currency}}

    .membership-pricing.xs-12.xs-mt-100m(v-if="hasMembershipPricing")
      p.one-time-price.bg-gray-light.xs-f-small.max-at-tweak One Time Purchase&nbsp;
        span.ada-tooltip(v-if="strikeOneTimePrice") strike
        span.price.xs-f-small.max-at-tweak(:class="{strike: strikeOneTimePrice }") {{oneTimePrice | currency}}
      p.membership-price.bg-blue-light.color-purple.semi-bold.xs-f-small.max-at-tweak(v-if="membershipPriceIsCheaper") Member Price&nbsp;
        span.price.xs-f-small.max-at-tweak {{membershipPrice | currency}}
  
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';

  export default {
    name: "CartXsellItem",

    props: {
      item: Object,
      index: Number
    },

    computed: {
      ...mapState('cart', ['addingProduct']),
      ...mapGetters('customer', ['hasMembershipPricing']),

      oneTimePrice() {
        return this.item.price_non_active_sub;
      },

      membershipPrice() {
        return this.item.price_active_member;
      },

      membershipPriceIsCheaper() {
        return this.oneTimePrice > this.membershipPrice;
      },

      strikeOneTimePrice() {
        return this.membershipPriceIsCheaper && this.item.price == this.membershipPrice;
      }
    },

    methods: {
      ...mapActions('cart', ['addToCart']),

      addItem() {
        if (this.addingProduct) {
          return;
        }

        this.addToCart({
          productId: this.item.id,
          cartType: 'active',
          ctaSource: 'cartXSell'
        });

        // AddToCart event for Facebook Pixel Tracking
        if (window.fbq) {
          window.fbq('track', 'AddToCart', {
            content_name: 'Shopping Cart',
            content_ids: [this.item.productTypeName + ' - ' + this.item.name],
            content_type: 'product',
            value: '' + item.price,
            currency: 'USD'
          });
        }
      }
    }
   }
</script>

<style scoped lang="stylus">
  .cart-xsell-item
    display inline-block
    vertical-align top
    width 25%
    padding 0 1%
    padding-bottom 1.5em
    
    button
      .icon-pos-circle
        &:before
          margin-left 0
    
    .membership-pricing
      .one-time-price
      .membership-price
        padding 0.65em
        width 100%
        
      .membership-price
        border-top 1px solid color-fog
        
      .one-time-price
        width 100%
    
    @media mq-mobile
      width 100%
      padding-left 0
      padding-right 0
      
      .item-details
        padding-left 1em
      
      .membership-pricing
        .price
          float right
      
    @media mq-tablet
      width 33%
      min-height 34em
      
      &.has-membership-pricing
        min-height 37em
        
    @media mq-desktop-md
      min-height 34em
      
      &.has-membership-pricing
        min-height 37em
        
    @media mq-desktop-plus
      min-height 32em
      
      &.has-membership-pricing
        min-height 35em
      
      .membership-pricing
        .price
          float right
      
</style>
